import { ConfigStateService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class TranslationSettingsService {
    constructor(private config: ConfigStateService, private http: HttpClient) { }

    public get translationEnabled(): boolean {
        return this.config.getSetting('Translation.Enabled').toLowerCase() === 'true'
            ? true
            : false;
    }

    private getApiUrl(): string {
      const apiBase = environment.apis.default.url;
  
      return apiBase;
    }
}
